import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { type LoyaltyUser, type LoyaltyUserUpdateInfo } from '@koala/sdk';
import * as Styled from '../styles';
import PrimaryButton from '@/components/checkout/uielements/primaryButton';
import StringAccessor from '@/components/cmsConfig/stringAccessor';

interface Props {
  updateMe: (params: Partial<LoyaltyUserUpdateInfo>) => void;
  me?: LoyaltyUser;
}

const UpdatePasswordForm: React.FC<Props> = ({ updateMe }) => {
  const { register, handleSubmit, reset, watch } = useForm();
  const [showClearButton, setShowClearButton] = useState(false);

  const onSubmit = (data: any) => {
    updateMe(data);
    reset();
  };

  const onClear = () => {
    reset();
    setShowClearButton(false);
  };

  const { current_password, password, password_confirmation } = watch();

  useEffect(() => {
    // if any form field is NOT an empty string, show clear button
    setShowClearButton(`${current_password}${password}${password_confirmation}` !== '');
  }, [current_password, password, password_confirmation]);

  return (
    <Styled.StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Styled.StyledInlineFormContainer>
        <Styled.StyledFormField>
          <Styled.FormInput
            {...register('current_password')}
            type="password"
            placeholder="Current Password"
            autoComplete="current-password"
            className="input"
          />
        </Styled.StyledFormField>
        <Styled.StyledFormField>
          <Styled.FormInput
            {...register('password')}
            type="password"
            placeholder="New Password"
            autoComplete="new-password"
            className="input"
          />
        </Styled.StyledFormField>
        <Styled.StyledFormField>
          <Styled.FormInput
            {...register('password_confirmation')}
            type="password"
            placeholder="Confirm New Password"
            autoComplete="confirm-new-password"
            className="input"
          />
        </Styled.StyledFormField>
      </Styled.StyledInlineFormContainer>
      <Styled.StyledCancelAndSubmitButtons>
        {/* Clear button */}
        {showClearButton && (
          <Styled.StyledCancelEdit>
            <Styled.StyledLinkButton
              type="button"
              onClick={onClear}
              aria-label="Clear password form"
            >
              Clear
            </Styled.StyledLinkButton>
          </Styled.StyledCancelEdit>
        )}
        {/* Submit Button */}
        <PrimaryButton
          type="submit"
          theme="secondary"
          $submitting={false}
          handleClick={() => null}
          $minWidth={150}
          aria-label="Submit Password Form"
        >
          <StringAccessor accessor="account.change_password_button" />
        </PrimaryButton>
      </Styled.StyledCancelAndSubmitButtons>
    </Styled.StyledForm>
  );
};

export default UpdatePasswordForm;
